import { render } from "./realName.vue?vue&type=template&id=042bc795&scoped=true"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"

import "./realName.vue?vue&type=style&index=0&id=042bc795&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042bc795"]])

export default __exports__